// Sections délégables de l'administration (alignées sur le menu admin et sur
// ADMIN_SECTIONS côté backend). Le super admin a accès à tout ; un sous-admin
// ne voit que les sections cochées dans sa fiche.
export const ADMIN_SECTIONS = [
  { perm: "dashboard", to: "/admin", label: "Tableau de bord" },
  { perm: "analytics", to: "/admin/analyse", label: "Analyse du trafic" },
  { perm: "projects", to: "/admin/projets", label: "Demandes / Projets" },
  { perm: "users", to: "/admin/utilisateurs", label: "Utilisateurs" },
  { perm: "partners", to: "/admin/liens", label: "Partenaires" },
  { perm: "ambassadors", to: "/admin/ambassadeurs", label: "Ambassadeurs" },
  { perm: "committee", to: "/admin/comite", label: "Comité de décision" },
  { perm: "weekly", to: "/admin/semaine", label: "Challenge de la semaine" },
  { perm: "press", to: "/admin/presse", label: "Marketing Presse" },
  { perm: "blog", to: "/admin/blog", label: "Blog" },
  { perm: "videos", to: "/admin/videos", label: "Vidéos" },
  { perm: "socials", to: "/admin/reseaux", label: "Réseaux sociaux" },
  { perm: "settings", to: "/admin/reglages", label: "Réglages du site" },
  { perm: "email", to: "/admin/reglages-email", label: "Réglages e-mail" },
  { perm: "security", to: "/admin/securite", label: "Sécurité" },
];

// Vrai si l'utilisateur est un sous-administrateur (permissions restreintes).
export const isSubAdmin = (user) => user?.role === "admin" && Array.isArray(user?.admin_permissions);

// Première route autorisée : utilisée pour rediriger un sous-admin après connexion
// ou lorsqu'il tente d'ouvrir une section interdite.
export const firstAllowedRoute = (user) => {
  if (!isSubAdmin(user)) return "/admin";
  const found = ADMIN_SECTIONS.find((s) => user.admin_permissions.includes(s.perm));
  return found ? found.to : "/admin";
};
